import getAll from 'utils/getAll'
import { apiUrls } from 'consts'
import ActionButtons from 'shared/components/ActionButtons'
import { NavLink } from 'react-router-dom'
import { IonIcon } from '@ionic/react'
import { eye, eyeOff, reorderFour, toggle } from 'ionicons/icons'

interface getRowsProps {
  setShowOverlay: Function
  handleToggleVisibility: Function
  handleSetDefaultSorting: Function
  setRowActionsClickCount: Function
}

const getRows = async (props: getRowsProps) => {
  let data = await getAll(apiUrls.deviceTableConfig, true)

  data.forEach((row: any, index: number, dataArray: any) => {
    const isVisible: boolean = row.visible === 1

    const actions = [
      {
        content: (
          <NavLink
            onClick={(e) => {
              props.handleToggleVisibility({
                id: row.id,
                setRowActionsClickCount: props.setRowActionsClickCount,
                setShowOverlay: props.setShowOverlay,
              })
            }}
            to='#'
            title={isVisible ? 'Hide Column' : 'Show Column'}
          >
            <IonIcon
              icon={isVisible ? eyeOff : eye}
              className='ionicon'
              style={{ fontSize: '16px' }}
            />
          </NavLink>
        ),
      },
    ]

    if (row.default !== 1) {
      actions.push({
        content: (
          <NavLink
            onClick={(e) => {
              props.handleSetDefaultSorting({
                id: row.id,
                setRowActionsClickCount: props.setRowActionsClickCount,
                setShowOverlay: props.setShowOverlay,
              })
            }}
            to='#'
            title={'Set as Default Sorting Column'}
          >
            <IonIcon icon={reorderFour} className='ionicon' style={{ fontSize: '16px' }} />
          </NavLink>
        ),
      })
    }

    dataArray[index].action = <ActionButtons buttons={actions} />

    dataArray[index].default = dataArray[index].default === 1 ? 'Yes' : 'No'
    dataArray[index].visible = dataArray[index].visible === 1 ? 'Yes' : 'No'
  })

  return data
}

export default getRows
